package ai.wagemix.logic.mixes

import co.touchlab.kermit.Severity
import com.fsryan.foundation.util.log.FSLog
import com.fsryan.foundation.util.log.sendEventInclusive

/*
 * The analytics events of the saved mixes presenter (planning/analytics-plan.md §5, "Saved and
 * shared mixes"). `mix_opened` is shared with the app shell and lives in FSLogWMStructuredEvents.kt.
 */

internal fun FSLog.sendWMMixDeleted(mixId: String) {
    sendEventInclusive(severity = Severity.Info, eventName = "WMMixDeleted") {
        put("mix_id", mixId)
    }
}
